import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import PublicHeader from "@/components/PublicHeader";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function PaymentResult({ cancelled }) {
  const [params] = useSearchParams();
  const { refresh } = useAuth();
  const [state, setState] = useState(cancelled ? "cancelled" : "checking");
  const [kind, setKind] = useState("subscription");

  useEffect(() => {
    if (cancelled) {
      return;
    }
    const sid = params.get("session_id");
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setKind(data.kind || "subscription"); setState(data.status === "refunded" || data.status === "refund_failed" ? "refunded" : "paid"); refresh(); return; }
        if (["expired", "failed"].includes(data.status)) { setState("failed"); return; }
      } catch (_) { /* keep polling */ }
      if (tries < 15) timer = setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
    return () => clearTimeout(timer);
  }, [cancelled, params, refresh]);

  const unlock = kind === "contact_unlock";
  const fee = kind === "placement_fee";
  const text = { checking: "Confirming your payment with Stripe…", paid: fee ? "Payment confirmed. Thank you — the placement fee is marked paid." : unlock ? "Payment confirmed. Your contact request was sent to the candidate." : "Payment confirmed. Your plan is now active.", cancelled: "Checkout was cancelled. You have not been charged.",
    refunded: "This candidate is no longer available, so no request was sent and your payment is being refunded to your card.",
    failed: "The payment did not complete.", timeout: "We could not confirm the payment yet. Check Plan & billing in a minute." }[state];
  return (
    <div className="min-h-screen"><PublicHeader />
      <main className="mx-auto max-w-lg px-4 py-24 text-center">
        <h1 className="text-3xl font-extrabold" data-testid="payment-result-title">{state === "paid" ? (fee ? "Placement fee paid" : unlock ? "Request sent" : "You're upgraded") : "Payment status"}</h1>
        <p className="mt-4 text-slate-600" data-testid="payment-result-message">{text}</p>
        <Button asChild className="mt-8 rounded-full" data-testid="payment-result-continue"><Link to={fee ? "/recruiter" : unlock ? "/recruiter/talent" : "/app/billing"}>{fee ? "Back to Employer portal" : unlock ? "Back to talent pool" : "Go to Plan & billing"}</Link></Button>
      </main>
    </div>
  );
}
